export enum KioskSoundMessage {
  SETTING_ENABLED_MESSAGE = 'Audio notification enabled',
  SETTING_DISABLED_MESSAGE = 'Audio notification disabled',
}
